// extracted by mini-css-extract-plugin
export default {"flex":"AssessmentIcon__flex___Te4y5"};